/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MyLQResults,
    MyLQResultsFromJSON,
    MyLQResultsFromJSONTyped,
    MyLQResultsToJSON,
    PotentialConditions,
    PotentialConditionsFromJSON,
    PotentialConditionsFromJSONTyped,
    PotentialConditionsToJSON,
    ResultStatus,
    ResultStatusFromJSON,
    ResultStatusFromJSONTyped,
    ResultStatusToJSON,
    RiskScore,
    RiskScoreFromJSON,
    RiskScoreFromJSONTyped,
    RiskScoreToJSON,
} from './';

/**
 * 
 * @export
 * @interface Assessment
 */
export interface Assessment {
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    lastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Assessment
     */
    dateOfBirth?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    age?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    govtId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    homeAddressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    homeCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    homeStateOrProvince?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    homePostalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    homePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    workPhone?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    expectedLongevityRank?: number;
    /**
     * 
     * @type {number}
     * @memberof Assessment
     */
    desiredLongevityRank?: number;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    owningUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    accessCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    riskClass?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Assessment
     */
    hipaaConsentId?: string | null;
    /**
     * 
     * @type {RiskScore}
     * @memberof Assessment
     */
    riskScore?: RiskScore;
    /**
     * 
     * @type {PotentialConditions}
     * @memberof Assessment
     */
    potentialConditions?: PotentialConditions;
    /**
     * 
     * @type {MyLQResults}
     * @memberof Assessment
     */
    myLQResult?: MyLQResults;
    /**
     * 
     * @type {ResultStatus}
     * @memberof Assessment
     */
    resultStatus?: ResultStatus;
    /**
     * 
     * @type {Array<MyLQResults>}
     * @memberof Assessment
     */
    variations?: Array<MyLQResults> | null;
}

export function AssessmentFromJSON(json: any): Assessment {
    return AssessmentFromJSONTyped(json, false);
}

export function AssessmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Assessment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'middleName': !exists(json, 'middleName') ? undefined : json['middleName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'dateOfBirth': !exists(json, 'dateOfBirth') ? undefined : (json['dateOfBirth'] === null ? null : new Date(json['dateOfBirth'])),
        'age': !exists(json, 'age') ? undefined : json['age'],
        'govtId': !exists(json, 'govtId') ? undefined : json['govtId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'homeAddressLine1': !exists(json, 'homeAddressLine1') ? undefined : json['homeAddressLine1'],
        'homeCity': !exists(json, 'homeCity') ? undefined : json['homeCity'],
        'homeStateOrProvince': !exists(json, 'homeStateOrProvince') ? undefined : json['homeStateOrProvince'],
        'homePostalCode': !exists(json, 'homePostalCode') ? undefined : json['homePostalCode'],
        'homePhone': !exists(json, 'homePhone') ? undefined : json['homePhone'],
        'mobilePhone': !exists(json, 'mobilePhone') ? undefined : json['mobilePhone'],
        'workPhone': !exists(json, 'workPhone') ? undefined : json['workPhone'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
        'expectedLongevityRank': !exists(json, 'expectedLongevityRank') ? undefined : json['expectedLongevityRank'],
        'desiredLongevityRank': !exists(json, 'desiredLongevityRank') ? undefined : json['desiredLongevityRank'],
        'owningUserId': !exists(json, 'owningUserId') ? undefined : json['owningUserId'],
        'accessCode': !exists(json, 'accessCode') ? undefined : json['accessCode'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'riskClass': !exists(json, 'riskClass') ? undefined : json['riskClass'],
        'hipaaConsentId': !exists(json, 'hipaaConsentId') ? undefined : json['hipaaConsentId'],
        'riskScore': !exists(json, 'riskScore') ? undefined : RiskScoreFromJSON(json['riskScore']),
        'potentialConditions': !exists(json, 'potentialConditions') ? undefined : PotentialConditionsFromJSON(json['potentialConditions']),
        'myLQResult': !exists(json, 'myLQResult') ? undefined : MyLQResultsFromJSON(json['myLQResult']),
        'resultStatus': !exists(json, 'resultStatus') ? undefined : ResultStatusFromJSON(json['resultStatus']),
        'variations': !exists(json, 'variations') ? undefined : (json['variations'] === null ? null : (json['variations'] as Array<any>).map(MyLQResultsFromJSON)),
    };
}

export function AssessmentToJSON(value?: Assessment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'firstName': value.firstName,
        'middleName': value.middleName,
        'lastName': value.lastName,
        'dateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth === null ? null : new Date(value.dateOfBirth).toISOString()),
        'age': value.age,
        'govtId': value.govtId,
        'email': value.email,
        'homeAddressLine1': value.homeAddressLine1,
        'homeCity': value.homeCity,
        'homeStateOrProvince': value.homeStateOrProvince,
        'homePostalCode': value.homePostalCode,
        'homePhone': value.homePhone,
        'mobilePhone': value.mobilePhone,
        'workPhone': value.workPhone,
        'height': value.height,
        'weight': value.weight,
        'expectedLongevityRank': value.expectedLongevityRank,
        'desiredLongevityRank': value.desiredLongevityRank,
        'owningUserId': value.owningUserId,
        'accessCode': value.accessCode,
        'gender': value.gender,
        'riskClass': value.riskClass,
        'hipaaConsentId': value.hipaaConsentId,
        'riskScore': RiskScoreToJSON(value.riskScore),
        'potentialConditions': PotentialConditionsToJSON(value.potentialConditions),
        'myLQResult': MyLQResultsToJSON(value.myLQResult),
        'resultStatus': ResultStatusToJSON(value.resultStatus),
        'variations': value.variations === undefined ? undefined : (value.variations === null ? null : (value.variations as Array<any>).map(MyLQResultsToJSON)),
    };
}


